module.exports = __webpack_public_path__ + "static/img/album4_202601_01.9b818e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album4_202601_01.jpg
// module id = 0GsW
// module chunks = 100